import { useState } from 'react';
import bk from '../Images/Login/bk.png'
import header from '../Images/Login/1.jpg'
import { Link, useNavigate } from "react-router-dom";
import CSS from "./login.module.css"
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

export default function Signup(props) {

    const auth = getAuth();

    const navigate = useNavigate();

    const [fullName, setfullName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault()

        if (password === confirmPassword) {
            await createUserWithEmailAndPassword(auth, email, password)
                .then(async (userCredential) => {
                    // Signed in
                    const user = userCredential.user;
                    await setDoc(doc(props.db, "users", auth.currentUser.uid), {
                        name: fullName,
                        email: email,
                        bookings: [],
                    });
                    console.log(user);
                    navigate("/")
                    // ...
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    console.log(errorCode, errorMessage);
                    // ..
                });
        }


    }

    return (
        <div>
            <section className="bsign" style={{ backgroundImage: `url(${bk})` }}>
                <a href="index.html"><div className="bheader" style={{ backgroundImage: `url(${header})` }}>
                </div></a>
                <div className="d-flex flex-column">
                    <div className="d-flex flex-column justify-content-center align-items-center full">
                        <div className="focus-in-expand">
                            <h1>Join Now!</h1>
                            <form className="d-flex flex-column justify-content-center">
                                <div className="form__group field">
                                    <input required placeholder="Name" className="form__field" type="Name" name="Name" value={fullName}
                                        onChange={(e) => setfullName(e.target.value)} />
                                    <label className="form__label" htmlfor="name">Full Name</label>
                                </div>
                                <div className="form__group field">
                                    <input required placeholder="Email" className="form__field" type="Email" name="Email" value={email}
                                        onChange={(e) => setEmail(e.target.value)} />
                                    <label className="form__label" htmlfor="Email">Email</label>
                                </div>
                                <div className="form__group field">
                                    <input required placeholder="Password" className="form__field" type="Password" name="Password" value={password}
                                        onChange={(e) => setPassword(e.target.value)} />
                                    <label className="form__label" htmlfor="Password">Password</label>
                                </div>
                                <div className="form__group field">
                                    <input required placeholder="Confirm Password" className="form__field" type="Password" name="ConfirmPassword" value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)} />
                                    <label className="form__label" htmlfor="Password">Confirm Password</label>
                                </div>
                                <span className="text-lg text-center text-white py-2">
                                    <span className="opacity-70">Already have an account? </span>
                                    <Link to="/login" className="text-white font-bold opacity-100 bg-transparent">Login</Link>
                                </span>
                                <button className={CSS.btn} onClick={onSubmit}>
                                    Create a new account
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}